export enum CommonPageViewTypes {
  Article = 'article',
  ArticlePreview = 'articlePreview',
  ArticleLayout = 'layout',
  Overview = 'overview',
  NotFound = '404',

  Other = 'other',
}
